import { render } from "./AdminFeedbacks.vue?vue&type=template&id=39cc0630&scoped=true"
import script from "./AdminFeedbacks.vue?vue&type=script&lang=js"
export * from "./AdminFeedbacks.vue?vue&type=script&lang=js"

import "./AdminFeedbacks.vue?vue&type=style&index=0&id=39cc0630&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cc0630"]])

export default __exports__